import { nature } from "@nature-ui/core";

export const Pre = (props) => (
  <nature.div className="my-8 rounded-sm" {...props} />
);
